module.exports = __webpack_public_path__ + "src/assets/img/start/d92e08b8e356395aa80394b2a18f4e68.png";